import {
  qrySupRegistAccountInfo,
  qrySupRegistBaseInfo,
  qrySupRegistHisPerform,
  qrySupRegistQualificationFileList,
  qrySupRegistContactInfo,
  qrySupWhiteListBySupName,
  qrySupRegistProductInfo,
  qrySupRegistFinanceInfo,
  qryApprovalRecord,
  checkSupplierInfoByMobile,
  qrySupBaseInfo,
  qrySupplierQualificationFile,
  qrySupHisPerform,
  qrySupFinanceInfo,
  qrySupplierProductInfo,
  qrySupplierLinkInfo
  /*qrySupCoopUnitList,*/
} from "../../api/supRegister";
import moment from "moment";
import detailBaseInfo from "@/setting/detail-base-info";
export const bidSupplierMixin = {
  data() {
    return {
      applyStateData: {}, //申请说明
      approvalRecordData: [], //审批记录
      accountInfo: {}, // 申请用户名信息
      basicInfoData: {}, //基本信息
      supplierContactData: {}, //供应商联系信息
      commonLinkInfoData: [], //常用联系人信息
      financeInfoData: {}, //财务信息
      productInfoData: [], //产品信息
      cooperationPerformanceData: {}, //合作业绩
      certificatesData: [], //资质文件信息
      cooperationUnitData: [], //供应商合作单位列表
      routeData: this.$route.query,
      supinfoId: this.$route.query.supinfoId, //供应商ID
      tempOrFormalFlag: "",
      supAuditId: "", //供应商审批信息ID
      approvalOperInfoBO: {}, //审批操作信息
      approving: "", // approving 审批中  sendback  审批退回     approvaled 审批通过
      approvingStatus: true, // 审批状态展示
      // //基本信息
      // supplierBaseInfo:
      //   this.$route.query.isOverseas + "" === "1"
      //     ? detailBaseInfo.foreign.supplierBaseInfo
      //     : this.unfreeze(detailBaseInfo.supplierBaseInfo),
      // //联系信息
      // supplierContact:
      //   this.$route.query.isOverseas + "" === "1"
      //     ? detailBaseInfo.foreign.supplierContact
      //     : this.unfreeze(detailBaseInfo.supplierContact),
      // //财务信息
      // financeInfo:
      //   this.$route.query.isOverseas + "" === "1"
      //     ? detailBaseInfo.foreign.financeInfo
      //     : this.unfreeze(detailBaseInfo.financeInfo),
      activities: [],
      isCredentials: "", //是否三证合一
      detailBaseInfo: detailBaseInfo,
      businessBillId: "",
      businessCode: "",
      businessBillType: "",
      businessAppId: "",
      businessOrgId: "",
      auditStatus: "", // 审批状态
      supInfoApplyId: "",
      mainstayTableData: [], //联系信息-主体信息
      djgTableData: []  //董监高
    };
  },
  created() {},
  activated() {},
  mounted() {},
  methods: {
    //审批页面及审批详情页面审批状态判断
    initLabelType() {
      switch (String(this.auditStatus)) {
        case "0":
          this.approvingStatus = false;
          break;
        case "1":
          this.$set(this, "approving", "approving");
          break;
        case "2":
          this.$set(this, "approving", "sendback");
          break;
        case "3":
          this.$set(this, "approving", "approvaled");
          break;
        case "4":
          this.$set(this, "approving", "withdrawn");
          break;
      }
      console.log(this.approving);
    },

    // 验证手机号
    checkSupplierMobile() {
      checkSupplierInfoByMobile({
        registMobile: this.routeData.registMobile
      }).then(res => {
        if (res.data.code === "0" && res.data.data.returnCheckCode === "") {
          this.searchRegisterCommon({
            supinfoId: res.data.data.supInfoApplyId,
            tempOrFormalFlag: res.data.data.tempOrFormalFlag
          });
          this.supAuditId = res.data.data.supAuditId;
          this.supInfoApplyId = res.data.data.supInfoApplyId;
          this.tempOrFormalFlag = res.data.data.tempOrFormalFlag;
        }
      });
    },

    // 查询供应商注册审批记录
    // getApprovalRecord() {
    //   qryApprovalRecord({
    //     businessBillId: this.businessBillId,
    //     businessCode: this.businessCode,
    //     businessBillType: this.businessBillType,
    //     businessAppId: this.businessAppId,
    //     businessOrgId: this.businessOrgId,
    //     isShowPageLoading: true
    //   }).then(res => {
    //     if (res.data.code === "0") {
    //       res.data.data.recordList.forEach((item, index) => {
    //         item.index = index + 1;
    //         item.operState = item.operState === 1 ? "已操作" : "未操作";
    //         item.operResultTypestr =
    //           item.operResultType === 1 ? "申请" : "审批";
    //       });
    //       this.$set(this, "approvalRecordData", res.data.data.recordList);
    //       this.$set(this, "activities", res.data.data.recordList);
    //     }
    //   });
    // },

    // 查询供应商合作单位列表
    /*getSupCoopUnitList() {
      qrySupCoopUnitList({
        supinfoId: this.supinfoId
      }).then(res => {
        if (res.data.code === "0") {
          this.cooperationUnitData = res.data.data.rows;
        }
      });
    },*/

    //查询供应商注册、变更信息
    searchRegisterCommon(data) {
      let params = {};
      if (data) {
        params = {
          supInfoApplyId: data.supinfoId,
          tempOrFormalFlag: data.tempOrFormalFlag,
          isShowPageLoading: true
        };
      } else {
        params = {
          supInfoApplyId: this.supinfoId,
          tempOrFormalFlag: this.tempOrFormalFlag,
          isShowPageLoading: true
        };
      }

      //申请用户名
      qrySupRegistAccountInfo(params).then(res => {
        if (res.data.code === "0") {
          console.log(res);
          let item = Object.assign(
            {},
            res.data.data.supRegistAccountInfoBO,
            res.data.data.supRegistAccountInfoBO.registAccountContactInfoBO
          );
          item.location = `${item.locationName || ""}${item.provinceName ||
            ""}${item.cityName || ""}${item.countyName || ""}`;
          item.password = "******";
          item.rePassword = "******";
          this.$set(this, "accountInfo", item);
        }
      });
      //基本信息
      qrySupRegistBaseInfo(
        Object.assign({}, params, { businessBillType: "P0701",applySpecifyOpenIdFlag:'1' })
      ).then(res => {
        if (res.data.code === "0") {
          qrySupWhiteListBySupName({
            supName:res.data.data.supRegistAccountInfoBO.supName
          }).then(obj=> {
            if (obj.data.data.rows.length > 0) {
              this.isWhite = true
            } else {
              this.isWhite = false
            }
            if (res.data.data.supRegistAccountInfoBO.locationCode == '980000' || res.data.data.supRegistAccountInfoBO.locationCode == '970000') {//地址海外 输入框校验逻辑和白名单一致，所以这里处理成白名单
              this.isHaiwaiorGAT = true
            }
            if (this.isWhite || this.isHaiwaiorGAT) {
              if (this.supplierBaseInfo1) {
                this.supplierBaseInfo1[3].displaynone = true
                this.supplierBaseInfo1[4].displaynone = true
              }
            }
          })

          this.auditStatus = res.data.data.auditStatus;
          this.initLabelType();
          let item = Object.assign(
            {},
            res.data.data.supRegistAccountInfoBO,
            res.data.data.supRegistBaseInfoBO,
            res.data.data.approvalOperInfoBO
          );
          for (let i in item) {
            if (i === "isOutSup" || i === "isInIndy") {
              if(window.languagezh_cn){
                item[i + "Comp"] = item[i] === 1 ? "是" : "否";
              }else{
                item[i + "Comp"] = item[i] === 1 ? "yes" : "no";
              }
            }
            if(!window.languagezh_cn){
              item.companyCategoryName=item.companyCategory=="B1"?'unit':'individual'
              if(item.companyCategory=="B1"){
                item.displaynone=true
              }
            }
          }
          item.location = `${item.locationName || ""}${item.provinceName ||
            ""}${item.cityName || ""}${item.countyName || ""}`;
          item.countryCode = `${item.locationName || ""}${item.countryName ||
            ""}`;
          this.currBreadCrumb &&
            this.$set(this.currBreadCrumb, "title", item.supName);
          this.$set(this, "basicInfoData", item || {});
          if (this.basicInfoData.isCredentials === 0) {
            this.$set(
              this.basicInfoData,
              "businessCode",
              res.data.data.supRegistAccountInfoBO.regNum
            );
          }
          this.$set(
            this,
            "approvalOperInfoBO",
            res.data.data.approvalOperInfoBO
          );
          this.$set(
            this.basicInfoData,
            "countryCode",
            `${item.locationName || ""}${item.countryName || ""}`
          );
          this.isCredentials = this.basicInfoData.isCredentials;
          this.businessBillId = res.data.data.approvalOperInfoBO.businessBillId;
          this.businessCode = res.data.data.approvalOperInfoBO.businessCode;
          this.businessBillType =
            res.data.data.approvalOperInfoBO.businessBillType;
          this.businessAppId = res.data.data.approvalOperInfoBO.appId;
          this.businessOrgId = res.data.data.approvalOperInfoBO.orgId;
          if (
            this.auditStatus + "" !== "" &&
            this.businessBillType + "" !== ""
          ) {
            qryApprovalRecord({
              businessBillId: this.businessBillId,
              businessCode: this.businessCode,
              businessBillType: this.businessBillType,
              businessAppId: this.businessAppId,
              businessOrgId: this.businessOrgId,
              isShowPageLoading: true
            }).then(res => {
              if (res.data.code === "0") {
                res.data.data.recordList.forEach((item, index) => {
                  item.index = index + 1;
                  item.operStateFlag = item.operState
                  item.operState = item.operState === 1 ? "已操作" : "未操作";
                  item.operResultTypestr =
                    item.operResultType === 1 ? "申请" : "审批";
                });
                this.$set(this, "approvalRecordData", res.data.data.recordList);
                res.data.data.recordList.forEach(item=>{
                  if(item.operResultType=="3"||item.operResultType=='11'){
                    item.operatorName = "****"
                  }
                })
                this.$set(this, "activities", res.data.data.recordList);
              }
            });
          }
          console.log(this.basicInfoData);
        }
      });
      //联系信息
      qrySupRegistContactInfo(params).then(res => {
        if (res.data.code === "0") {
          this.$set(
            this,
            "supplierContactData",
            res.data.data.supRegistContactInfoBO || {}
          );
          this.$set(
            this,
            "commonLinkInfoData",
            res.data.data.commonSupContactInfoBOList || []
          );
          this.mainstayTableData = res.data.data.supRegistContactInfoBO.supTempMainstayInfoBOS;
          this.djgTableData = res.data.data.supRegistContactInfoBO.supTempDjgInfoBOS;
        }
      });
      //产品信息
      qrySupRegistProductInfo(params).then(res => {
        if (res.data.code === "0") {
          this.$set(
            this,
            "productInfoData",
            res.data.data.supRegistProductInfoList || []
          );
        }
      });
      // //财务信息
      qrySupRegistFinanceInfo(params).then(res => {
        if(!window.languagezh_cn){
          let item = res.data.data.supRegistPayInfoBO
          if(item.isAccp==1){
            item.isAccpName="yes"
          }else{
            item.isAccpName="no"
          }
        }
        if (res.data.code === "0") {
          this.$set(
            this,
            "financeInfoData",
            res.data.data.supRegistPayInfoBO || {}
          );
        }
      });
      //合作业绩
      qrySupRegistHisPerform(params).then(res => {
        console.log(res);
        if (res.data.code === "0") {
          if (
            res.data.data.supRegistHisPerformBO.cooperEnterprise.charAt(
              res.data.data.supRegistHisPerformBO.cooperEnterprise.length - 1
            ) === ","
          ) {
            res.data.data.supRegistHisPerformBO.cooperEnterprise = res.data.data.supRegistHisPerformBO.cooperEnterprise.substring(
              0,
              res.data.data.supRegistHisPerformBO.cooperEnterprise.length - 1
            );
          }
          this.$set(
            this,
            "cooperationPerformanceData",
            res.data.data.supRegistHisPerformBO || {}
          );
        }
        console.log(this.cooperationPerformanceData);
      });
      //资质文件
      qrySupRegistQualificationFileList(params).then(res => {
        if (res.data.code === "0") {
          this.$set(
            this,
            "certificatesData",
            res.data.data.supRegistQualFileInfoList || []
          );
        }
      });
    },

    searchOtherCommon(id, businessBillType, code) {
      let params = {
        supinfoId: id ? id : this.supinfoId,
        businessBillType: businessBillType
          ? businessBillType
          : this.routeData.businessBillType,
        isShowPageLoading: id ? false : true
      };
      if (code) {
        params.supCode = code;
      }
      //基本信息
      qrySupBaseInfo(params).then(res => {
        if (res.data.code === "0") {
          let item = Object.assign(
            {},
            res.data.data.supBaseInfoBO,
            res.data.data.supAccountInfoBO
          );
          for (let i in item) {
            if (i === "isOutSup" || i === "isInIndy") {
              if(window.languagezh_cn){
                item[i + "Comp"] = item[i] === 1 ? "是" : "否";
              }else{
                item[i + "Comp"] = item[i] === 1 ? "yes" : "no";
              }
            }
          }
          item.location = `${item.locationName || ""}${item.provinceName ||
            ""}${item.cityName || ""}${item.countyName || ""}`;
          this.currBreadCrumb &&
            this.$set(this.currBreadCrumb, "title", item.supName);
          this.$set(this, "basicInfoData", item || {});
          this.$set(
            this,
            "approvalOperInfoBO",
            res.data.data.approvalOperInfoBO
          );
        }
      });
      //联系信息
      qrySupplierLinkInfo({
        supinfoId: id ? id : this.supinfoId,
        supCode: code ? code : ""
      }).then(res => {
        if (res.data.code === "0") {
          this.$set(
            this,
            "supplierContactData",
            res.data.data.supContactBO || {}
          );
          this.$set(
            this,
            "commonLinkInfoData",
            res.data.data.commonSupContactInfoBOList || []
          );
        }
      });
      //产品信息
      qrySupplierProductInfo(params).then(res => {
        if (res.data.code === "0") {
          this.$set(this, "productInfoData", res.data.data.rows || []);
        }
      });
      //财务信息
      qrySupFinanceInfo({
        supInfoApplyId: id ? id : this.supinfoId,
        supCode: code ? code : ""
      }).then(res => {
        if (res.data.code === "0") {
          this.$set(this, "financeInfoData", res.data.data.supPayInfoBO || {});

        }
      });
      //合作业绩
      qrySupHisPerform(params).then(res => {
        if (res.data.code === "0") {
          if (
            res.data.data.supHisPerformBO.cooperEnterprise.charAt(
              res.data.data.supHisPerformBO.cooperEnterprise.length - 1
            ) === ","
          ) {
            res.data.data.supHisPerformBO.cooperEnterprise = res.data.data.supHisPerformBO.cooperEnterprise.substring(
              0,
              res.data.data.supHisPerformBO.cooperEnterprise.length - 1
            );
          }
          this.$set(
            this,
            "cooperationPerformanceData",
            res.data.data.supHisPerformBO || {}
          );
        }
      });
      //资质文件
      qrySupplierQualificationFile(params).then(res => {
        if (res.data.code === "0") {
          this.$set(this, "certificatesData", res.data.data.rows || []);
        }
      });
    },
    handleBack() {
      this.$router.go(-1);
    },
    //解冻
    unfreeze(data) {
      return JSON.parse(JSON.stringify(data));
    }
  },
  watch: {
    isCredentials(val) {
      if (val + "" === "1") {
        this.supplierAccountInfoBO1.splice(5, 4);
        console.log(this.supplierAccountInfoBO1);
        this.supplierBaseInfo1.splice(12, 3);
        if(this.accountInfo.locationCode=='970000'){
          this.supplierAccountInfoBO1.splice(2, 1);
          this.supplierAccountInfoBO1[2].label="港澳台统一代码证:"
          this.supplierBaseInfo1.splice(8, 1);
          this.supplierBaseInfo1[7].label="港澳台统一代码证:"
        }
      } else {
        this.supplierAccountInfoBO1.splice(3, 1);
        this.supplierBaseInfo1.splice(10, 1);
      }
    }
  }
};
